import { Routes } from '@angular/router';
import { RoleGuard } from '../Authentication/guards/role.guard';
import { Role } from '../Authentication/models/roles-permissions.model';
import { NgxPermissionsRouterData } from 'ngx-permissions';

export const ADMIN_ROUTES: Routes = [
    {
        path: "",
        canActivate: [RoleGuard],
        data: {
            roles: {
                only: [Role.SiteAdministrator, Role.SuperAdministrator],
                redirectTo: "/error/access-denied",
            } as NgxPermissionsRouterData,
        },
        children: [
            {
                path: "",
                loadComponent: () =>
                    import("./layouts/main-admin-layout/main-admin-layout.component").then(
                        (m) => m.MainAdminLayoutComponent
                    ),
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./components/admin-dashboard/admin-dashboard.component").then(
                                (m) => m.AdminDashboardComponent
                            ),
                    },
                    {
                        path: "dashboard",
                        loadComponent: () =>
                            import("./components/admin-dashboard/admin-dashboard.component").then(
                                (m) => m.AdminDashboardComponent
                            ),
                    },
                    {
                        path: "account",
                        children: [
                            {
                                path: "my-profile",
                                loadComponent: () =>
                                    import("./components/update-system-user/update-system-user.component").then(
                                        (m) => m.UpdateSystemUserComponent
                                    ),
                            },
                        ],
                    },
                    {
                        path: "updateProfile",
                        loadComponent: () =>
                            import("../Shared/components/update-profile/update-profile.component").then(
                                (m) => m.UpdateProfileComponent
                            ),
                    },
                    {
                        path: "sections",
                        loadComponent: () =>
                            import("./components/sections-and-categories/sections-and-categories.component").then(
                                (m) => m.SectionsAndCategoriesComponent
                            ),
                    },
                    {
                        path: "standardPages",
                        loadComponent: () =>
                            import("./components/standard-pages/standard-pages.component").then(
                                (m) => m.StandardPagesComponent
                            ),
                    },
                    {
                        path: "categories/:section",
                        loadComponent: () =>
                            import("./components/categories/categories.component").then(
                                (m) => m.CategoriesComponent
                            ),
                    },
                    {
                        path: "vendors",
                        loadComponent: () =>
                            import("./components/admin-vendor-tabs/admin-vendor-tabs.component").then(
                                (m) => m.AdminVendorTabsComponent
                            ),
                    },
                    {
                        path: "createCategory/:section",
                        loadComponent: () =>
                            import("./components/create-category/create-category.component").then(
                                (m) => m.CreateCategoryComponent
                            ),
                    },
                    {
                        path: "createSections",
                        loadComponent: () =>
                            import("./components/create-sections/create-sections.component").then(
                                (m) => m.CreateSectionsComponent
                            ),
                    },
                    {
                        path: "addVendor",
                        loadComponent: () =>
                            import("./components/add-vendor/add-vendor.component").then(
                                (m) => m.AddVendorComponent
                            ),
                    },
                    {
                        path: "brands",
                        loadComponent: () =>
                            import("../Shared/components/brand-tabs/brand-tabs.component").then(
                                (m) => m.BrandTabsComponent
                            ),
                    },
                    {
                        path: "giTags",
                        loadComponent: () =>
                            import("../Admin/components/gi-tags-approval/gi-tags-approval.component").then(
                                (m) => m.GiTagsApprovalComponent
                            ),
                    },
                    {
                        path: "propertiesAndLabels",
                        loadComponent: () =>
                            import("../Admin/components/properties-and-labels/properties-and-labels.component").then(
                                (m) => m.PropertiesAndLabelsComponent
                            ),
                    },
                    {
                        path: "shippingAndHandling",
                        loadComponent: () =>
                            import("./components/shipping-and-handling/shipping-and-handling.component").then(
                                (m) => m.ShippingAndHandlingComponent
                            ),
                    },
                    {
                        path: "createShippingMethod",
                        loadComponent: () =>
                            import("./components/create-shipping-method/create-shipping-method.component").then(
                                (m) => m.CreateShippingMethodComponent
                            ),
                    },
                    {
                        path: "createShippingCost",
                        loadComponent: () =>
                            import("./components/create-shipping-cost/create-shipping-cost.component").then(
                                (m) => m.CreateShippingCostComponent
                            ),
                    },
                    {
                        path: "siteAddress",
                        loadComponent: () =>
                            import("./components/site-address/site-address.component").then(
                                (m) => m.SiteAddressComponent
                            ),
                    },
                    {
                        path: "policies",
                        loadComponent: () =>
                            import("./components/policies/policies.component").then(
                                (m) => m.PoliciesComponent
                            ),
                    },
                    {
                        path: "vendor-policies",
                        loadComponent: () =>
                            import("./components/vendor-policies/vendor-policies.component").then(
                                (m) => m.VendorPoliciesComponent
                            ),
                    },
                    {
                        path: "webPages",
                        loadComponent: () =>
                            import("./web-pages/web-pages.component").then(
                                (m) => m.WebPagesComponent
                            ),
                    },
                    {
                        path: "externalLinks",
                        loadComponent: () =>
                            import("./components/external-links/external-links.component").then(
                                (m) => m.ExternalLinksComponent
                            ),
                    },
                    {
                        path: "updateExternalLinks",
                        loadComponent: () =>
                            import("./components/update-external-link/update-external-link.component").then(
                                (m) => m.UpdateExternalLinkComponent
                            ),
                    },
                    {
                        path: "createWebPage",
                        loadComponent: () =>
                            import("./components/create-web-page/create-web-page.component").then(
                                (m) => m.CreateWebPageComponent
                            ),
                    },
                    {
                        path: "createExternalLinks",
                        loadComponent: () =>
                            import("./components/create-external-links/create-external-links.component").then(
                                (m) => m.CreateExternalLinksComponent
                            ),
                    },
                    {
                        path: "updateWebPage/:id",
                        loadComponent: () =>
                            import("./components/update-web-page/update-web-page.component").then(
                                (m) => m.UpdateWebPageComponent
                            ),
                    },
                    {
                        path: "catalog",
                        loadComponent: () =>
                            import("./components/catalog-components/site-catalog-list/site-catalog-list.component").then(
                                (m) => m.SiteCatalogListComponent
                            ),
                    },
                    {
                        path: "addCatalog",
                        loadComponent: () =>
                            import("./components/catalog-components/add-catalog/add-siteCatalog.component").then(
                                (m) => m.AddSiteCatalogComponent
                            ),
                    },
                    {
                        path: "siteCatalogItems",
                        loadComponent: () =>
                            import("./components/catalog-components/catalog-items-list/catalog-items-list.component").then(
                                (m) => m.CatalogItemsListComponent
                            ),
                    },
                    {
                        path: "add-item",
                        loadComponent: () =>
                            import("../Shared/components/vendor-tabs/vendor-tabs.component").then(
                                (m) => m.VendorTabsComponent
                            ),
                    },
                    {
                        path: "linkFromMaster",
                        loadComponent: () =>
                            import("./components/catalog-components/link-master-catalog-items/link-master-catalog-items.component").then(
                                (m) => m.LinkMasterCatalogItemsComponent
                            ),
                    },
                    {
                        path: "stock/:catalogItemStyle",
                        loadComponent: () =>
                            import("../Shared/components/vendor-stock/vendor-stock.component").then(
                                (m) => m.VendorStockComponent
                            ),
                    },
                    {
                        path: "view-product/:item",
                        loadComponent: () =>
                            import("../Shared/components/vendor-product-details/vendor-product-details.component").then(
                                (m) => m.VendorProductDetailsComponent
                            ),
                    },
                    {
                        path: "menuItems",
                        loadComponent: () =>
                            import("./header-menu-items/header-menu-items.component").then(
                                (m) => m.HeaderMenuItemsComponent
                            ),
                    },
                    {
                        path: "createMenu",
                        loadComponent: () =>
                            import("./components/create-menu-items/create-menu-items.component").then(
                                (m) => m.CreateMenuItemsComponent
                            ),
                    },
                    {
                        path: "updateMenuItem",
                        loadComponent: () =>
                            import("./components/update-menu-item/update-menu-item.component").then(
                                (m) => m.UpdateMenuItemComponent
                            ),
                    },
                    {
                        path: "vendor-docs",
                        loadComponent: () =>
                            import("./components/vendor-documents/vendor-documents.component").then(
                                (m) => m.VendorDocumentsComponent
                            ),
                    },
                    {
                        path: "createbanner",
                        loadComponent: () =>
                            import("./components/create-banner-images/create-banner-images.component").then(
                                (m) => m.CreateBannerImagesComponent
                            ),
                    },
                    {
                        path: "createSubCategory/:category",
                        loadComponent: () =>
                            import("./components/create-sub-categories/create-sub-categories.component").then(
                                (m) => m.CreateSubCategoriesComponent
                            ),
                    },
                    {
                        path: "subCategories/:category",
                        loadComponent: () =>
                            import("./components/sub-categories/sub-categories.component").then(
                                (m) => m.SubCategoriesComponent
                            ),
                    },
                    {
                        path: "innerSubCategories/:subCategory",
                        loadComponent: () =>
                            import("./components/inner-sub-categories/inner-sub-categories.component").then(
                                (m) => m.InnerSubCategoriesComponent
                            ),
                    },
                    {
                        path: "bannerImages",
                        loadComponent: () =>
                            import("./components/create-banner-images/create-banner-images.component").then(
                                (m) => m.CreateBannerImagesComponent
                            ),
                    },
                    {
                        path: "createInnerSubCategory/:subCategory",
                        loadComponent: () =>
                            import("./components/create-inner-sub-category/create-inner-sub-category.component").then(
                                (m) => m.CreateInnerSubCategoryComponent
                            ),
                    },
                    {
                        path: "merchants",
                        loadComponent: () =>
                            import("./components/merchants/merchants.component").then(
                                (m) => m.MerchantsComponent
                            ),
                    },
                    {
                        path: "site-list",
                        loadComponent: () =>
                            import("./components/sites-list/sites-list.component").then(
                                (m) => m.SitesListComponent
                            ),
                    },
                    {
                        path: "site-configure",
                        loadComponent: () =>
                            import("./components/site-setting/site-setting.component").then(
                                (m) => m.SiteSettingComponent
                            ),
                    },
                    {
                        path: "companies",
                        loadComponent: () =>
                            import("./components/companies-list/companies-list.component").then(
                                (m) => m.CompaniesListComponent
                            ),
                    },
                    {
                        path: "add-company",
                        loadComponent: () =>
                            import("./components/create-company/create-company.component").then(
                                (m) => m.CreateCompanyComponent
                            ),
                    },
                    {
                        path: "addImages/:section/:category",
                        loadComponent: () =>
                            import("../Shared/components/add-images/add-images.component").then(
                                (m) => m.AddImagesComponent
                            ),
                    },
                    {
                        path: "site-users",
                        loadComponent: () =>
                            import("./components/site-users/site-users.component").then(
                                (m) => m.SiteUsersComponent
                            ),
                    },
                    {
                        path: "site-roles",
                        loadComponent: () =>
                            import("./components/site-roles/site-roles.component").then(
                                (m) => m.SiteRolesComponent
                            ),
                    },
                    {
                        path: "addUser",
                        loadComponent: () =>
                            import("./components/create-user/create-user.component").then(
                                (m) => m.CreateUserComponent
                            ),
                    },
                    {
                        path: "addRole",
                        loadComponent: () =>
                            import("./components/create-role/create-role.component").then(
                                (m) => m.CreateRoleComponent
                            ),
                    },
                    {
                        path: "retail-products",
                        loadComponent: () =>
                            import("./components/product-approval-tabs/product-approval-tabs.component").then(
                                (m) => m.ProductApprovalTabsComponent
                            ),
                    },
                    {
                        path: "wholesale-products",
                        loadComponent: () =>
                            import("./components/product-approval-tabs/product-approval-tabs.component").then(
                                (m) => m.ProductApprovalTabsComponent
                            ),
                    },
                    {
                        path: "verify-product",
                        loadComponent: () =>
                            import("./components/verify-prodcut/verify-prodcut.component").then(
                                (m) => m.VerifyProdcutComponent
                            ),
                    },
                    {
                        path: "wholesalers",
                        loadComponent: () =>
                            import("./components/admin-vendor-tabs/admin-vendor-tabs.component").then(
                                (m) => m.AdminVendorTabsComponent
                            ),
                    },
                    {
                        path: "business-customers",
                        loadComponent: () =>
                            import("./components/admin-vendor-tabs/admin-vendor-tabs.component").then(
                                (m) => m.AdminVendorTabsComponent
                            ),
                    },
                    {
                        path: "view-product",
                        loadComponent: () =>
                            import("../Shared/components/vendor-product-details/vendor-product-details.component").then(
                                (m) => m.VendorProductDetailsComponent
                            ),
                    },
                    // Duplicated "site-setting" entry found in original code was preserved for accuracy
                    {
                        path: "site-setting",
                        loadComponent: () =>
                            import("./components/site-setting/site-setting.component").then(
                                (m) => m.SiteSettingComponent
                            ),
                    },
                ],
            },
        ],
    },
];